import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { wmsApi, fmtKg2, fmtDate } from "./wmsApi";
import { WCard, WBadge } from "./WmsUi";

export default function WmsStock() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState({});

  useEffect(() => { wmsApi.get("/wms/stock").then((r) => setData(r.data)).catch(() => {}); }, []);

  if (!data) return <p className="text-zinc-500 py-8">Caricamento...</p>;

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <h1 className="font-['Chivo'] font-black text-3xl tracking-tighter uppercase">Giacenze</h1>
        <p className="font-bold text-zinc-700" data-testid="stock-totals">
          {data.totals.products} articoli · {data.totals.pieces} pezzi · <span className="font-['Chivo'] font-black text-xl">{fmtKg2(data.totals.kg)} kg</span>
        </p>
      </div>

      <div className="space-y-2">
        {data.rows.map((g) => (
          <WCard key={g.product_id} className="border-2 border-zinc-300">
            <button className="w-full p-4 flex items-center gap-3 text-left" onClick={() => setOpen({ ...open, [g.product_id]: !open[g.product_id] })} data-testid={`stock-row-${g.product_code}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font-bold truncate">{g.product_name}</p>
                  <WBadge tone="dark">{g.category_name || "—"}</WBadge>
                </div>
                <p className="text-xs text-zinc-400 font-mono">{g.product_code}</p>
              </div>
              <div className="text-right shrink-0">
                <p className="font-['Chivo'] font-black text-xl">{fmtKg2(g.kg)} kg</p>
                <p className="text-xs text-zinc-500">{g.pieces} pezzi · {g.units} pz</p>
              </div>
              {open[g.product_id] ? <ChevronUp className="w-5 h-5 shrink-0" /> : <ChevronDown className="w-5 h-5 shrink-0" />}
            </button>
            {open[g.product_id] && (
              <div className="border-t border-zinc-200 divide-y divide-zinc-100">
                {g.lots.map((l) => (
                  <div key={l.lot_id} className="px-4 py-2.5 flex items-center gap-3 text-sm flex-wrap" data-testid={`stock-lot-${l.internal_lot}`}>
                    <span className="font-mono font-bold">{l.internal_lot}</span>
                    <span className="text-zinc-500">forn. {l.lot_supplier || "—"}</span>
                    <WBadge>{l.packaging}</WBadge>
                    {l.expiry_date && <span className="text-zinc-500">scad. {fmtDate(l.expiry_date)}</span>}
                    <span className="flex-1" />
                    {Object.entries(l.brands || {}).map(([b, n]) => b !== "—" && <WBadge key={b} tone="orange">{b} ×{n}</WBadge>)}
                    <span className="font-bold">{fmtKg2(l.kg)} kg · {l.pieces} pezzi</span>
                  </div>
                ))}
              </div>
            )}
          </WCard>
        ))}
        {data.rows.length === 0 && <WCard className="p-8 text-center text-zinc-500" data-testid="stock-empty">Nessuna giacenza: registra il primo carico.</WCard>}
      </div>
    </div>
  );
}
